module.exports = __webpack_public_path__ + "15f727af.svg";